import { Environment } from '../utils/environment';

export const FLAGSMITH_ENV_ID: Record<Environment, string> = {
  [Environment.LOCAL]: 'AkyHP2wBjtmfaSzjCEvGNE',
  [Environment.DEVMAJ]: 'AkyHP2wBjtmfaSzjCEvGNE',
  [Environment.MAJSTG]: 'KWbiYDFLCbXWuHChKnJfez',
  [Environment.PROD]: 'noF7ZmcLCLxn7D5csG4Xyh',
};

export function getFlagsmithEnvId(env: string): string {
  return FLAGSMITH_ENV_ID[env as Environment];
}
